// Saved selections are history, never authorization for public learning.
export default function PreviewUnlockOverlay({ children }) { return children; }